<template>
  <div v-if="loading" class="shadow-lg bg-white rounded-full px-6 py-2 absolute font-bold -mr-6 mt-2" style="top: -15px; right: 9px;">
    <d-loader color="green" :size="20" class="p-0 m-0" />
  </div>
  <div v-else>
    <!-- Cost Chip -->
    <div v-if="!listingStatus.paid && parseCost" class="shadow-lg bg-white rounded-full px-6 py-2 absolute font-bold -mr-6 mt-2 text-green" style="top: -15px; right: 9px;">
      ${{ parseCost }}
    </div>
    <div v-else-if="listingStatus.completed" class="shadow-lg bg-white rounded-full px-6 py-2 absolute font-bold -mr-6 mt-2 text-green flex items-center" style="top: -15px; right: 9px;">
      <d-icon icon="check" class="mr-2" /> Completed
    </div>

    <!-- Favorite Chip -->
    <div v-if="loggedIn">
      <div v-if="listingStatus.isFavorite" class="shadow-lg bg-white rounded-full p-3 absolute font-bold -mr-6 mt-2 text-secondary-400 flex items-center" style="top: -15px; left: -15px;" @click.prevent.stop="toggleFavorite">
        <d-icon icon="star" />
      </div>
      <div v-else-if="!listingStatus.isFavorite" class="shadow-lg bg-white rounded-full p-3 absolute font-bold -mr-6 mt-2 text-black flex items-center" style="top: -15px; left: -15px;" @click.prevent.stop="toggleFavorite">
        <d-icon icon="star" />
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted } from 'vue';
  import axios from 'axios';
  // Import Pinia auth store
  import { useAuthStore } from '@stores/auth';

  export default {
    props: {
      content: {
        type: Object,
        default: () => ({}),
      },
    },

    setup(props) {
      // Reactive data
      const loading = ref(true);
      const listingStatus = ref({});
      
      // Auth store
      const authStore = useAuthStore();

      // Computed properties
      const loggedIn = computed(() => authStore?.loggedIn || false);
      
      const parseCost = computed(() => {
        if (Number.isNaN(props.content.cost) || props.content.cost === 0) {
          return null;
        }
        return props.content.cost.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2 });
      });

      // Methods
      const getStatus = async () => {
        try {
          const { data } = await axios.get(`/api/content-listings/${props.content.id}/status`);
          listingStatus.value = data;
        } catch (error) {
          console.error('Error fetching content status:', error);
          listingStatus.value = {};
        } finally {
          loading.value = false;
        }
      };

      const toggleFavorite = async () => {
        try {
          await axios.post(`/api/content-listings/${props.content.id}/favorite`);
          listingStatus.value.isFavorite = !listingStatus.value.isFavorite;
        } catch (error) {
          console.error('Error toggling favorite:', error);
        }
      };

      // Initialize on mount
      onMounted(() => {
        getStatus();
      });

      return {
        loading,
        listingStatus,
        loggedIn,
        parseCost,
        getStatus,
        toggleFavorite
      };
    },
  };
</script>